export default "__VITE_ASSET__CyTsUFQR__"